export const STRINGS = {
    EMPTY: "",
    TIMEOUT:  "timeout"
}

export const DARK_MODE = {
    DARK: "dark",
    LIGHT: "light",
}

export const VIEW_FMC_ROLE = "AmazonFacility::Feature Management Console Viewer";

export const EDIT_FMC_ROLE = "AmazonFacility::Feature Management Console Editor";

export const TCP_ROLES_HEADER = "tcp-roles";

export const CONFIG_TYPES = {SDC: "SDC", G2S2: "G2S2", AWS_APP_CONFIG: "AWS_APP_CONFIG", GROK :"GROK"}

export const DEFAULT_ERROR_MESSAGE = "Encountered an error."

export const STATION_CODE = "stationCode";
export const VALUE = "value";

export const LAUNCH_STATUS_IDENTIFIER = {LAUNCH_STATUS_YES: "Yes", LAUNCH_STATUS_NO: "No"};

export const LAUNCH_STATUS_CSV_HEADER = {STATION : "Station", PROGRAM_STATUS: "PROGRAM STATUS"};

export const LAUNCH_STATUS_STATES = { ENABLED: "ENABLED",
    PARTIALLY_ENABLED: "PARTIALLY ENABLED", DISABLED : "DISABLED"}

export const LAUNCH_STATUS_LIST_IDENTIFIER = "FEATURE";

export const ALERT_TYPES = {WARNING: "warning", SUCCESS: "success", ERROR: "error"}

export const SDC_FIELD_TYPES = {JSON: "JSON", STRING: "STRING", LIST: "LIST"}
export const GROK_FIELD_TYPES = {JSON: "JSON", STRING: "STRING", LIST: "LIST"}

export const AWS_APP_CONFIG_FIELD_TYPES = {JSON: "JSON", LIST: "LIST"}

// Value types offered for the ADD_NODE_WITH_CUSTOM_VALUE template's per-config custom value.
export const CUSTOM_VALUE_TYPES = {JSON: "JSON", STRING: "STRING", LIST: "LIST"}

// AWS App Config template whose per-config custom value is entered at config-creation time and
// written as {nodeId: value} at enable. Gates the custom-value textarea + type select in the UI.
export const ADD_NODE_WITH_CUSTOM_VALUE_TEMPLATE = "ADD_NODE_WITH_CUSTOM_VALUE"

export const GRANULARITY_LEVELS = {STATION: "STATION", CYCLE: "CYCLE"}

export const EDIT_FEATURE_ACTIONS = {
    CREATE_FEATURE: {name: "CREATE_FEATURE", description: "Create new config with new feature"},
    ADD_CONFIGS: {name: "ADD_CONFIGS", description: "Create new config for existing feature"},
    REMOVE_CONFIGS: {name: "REMOVE_CONFIGS", description: "Remove configs from existing feature"}
}

export const EDIT_PROGRAM_ACTIONS = {
    CREATE_PROGRAM: {name: "CREATE_PROGRAM", description: "Create new Program"},
    ADD_FEATURES: {name: "ADD_FEATURES", description: "Add Features to Program"},
    REMOVE_FEATURES: {name: "REMOVE_FEATURES", description: "Remove Features from Program"}
}

export const G2S2_FIELD_TYPES = {SYMBOL: "SYMBOL", STRING: "STRING", BOOLEAN: "BOOLEAN"}

export const LAUNCH_STATUS_HEADERS = ["Config_Name", "Enabled", "Disabled", "Partially Enabled"];

export const BOOLEAN_VALUES = {TRUE: "true", FALSE: "false"}

export const NFMS_TARGET_PREFIX = "com.amazon.nodefeaturemanagementservice.NodeFeatureManagementService."

export const NFMS_ENDPOINT_MAP = {
    "NAAmazon-beta": "https://endpoint-beta.nfms.last-mile.amazon.dev",
    "NAAmazon-gamma": "https://endpoint-gammana.nfms.last-mile.amazon.dev",
    "EUAmazon-gamma": "https://endpoint-gammaeu.nfms.last-mile.amazon.dev",
    "JPAmazon-gamma": "https://endpoint-gammajp.nfms.last-mile.amazon.dev",
    "INAmazon-gamma": "https://endpoint-gammain.nfms.last-mile.amazon.dev",
    "NAAmazon-prod": "https://endpoint-na.nfms.last-mile.amazon.dev",
    "EUAmazon-prod": "https://endpoint-eu.nfms.last-mile.amazon.dev",
    "JPAmazon-prod": "https://endpoint-jp.nfms.last-mile.amazon.dev",
    "INAmazon-prod": "https://endpoint-in.nfms.last-mile.amazon.dev"
}

export const MARKETPLACE_LOCALE_MAP = {
    de: ["de", "de-DE", "de-CH", "de-AT", "de-LU", "de-LI"],
    es: ["es", "es-ES", "es-AR", "es-GT", "es-CR", "es-PA", "es-DO", "es-MX", "es-VE", "es-CO",
        "es-PE", "es-EC", "es-CL", "es-UY", "es-PY", "es-BO", "es-SV", "es-HN", "es-NI", "es-PR"],
    ja: ["ja", "ja-JP"],
    it: ["it", "it-IT", "it-CH"],
    fr: ["fr", "fr-FR", "fr-BE", "fr-CA", "fr-CH", "fr-LU"],
    ar: ["ar", "ar-SA", "ar-IQ", "ar-EG", "ar-LY", "ar-DZ", "ar-MA", "ar-TN", "ar-OM", "ar-YE",
        "ar-SY", "ar-JO", "ar-LB", "ar-KW", "ar-AE", "ar-BH", "ar-QA"],
    en: ["en"]
}



// WEBPACK FOOTER //
// ./src/Constants.js